import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_a_cascader = _resolveComponent("a-cascader")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_cascader, {
      value: _ctx.innerValue,
      "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.innerValue) = $event)),
      options: _ctx.options,
      disabled: _ctx.disabled,
      "change-on-select": _ctx.changeOnSelect,
      placeholder: _ctx.placeholder,
      "field-names": { label: 'name', value: 'id', children: 'children' },
      "load-data": _ctx.loadData,
      onChange: _ctx.onChange,
      class: _normalizeClass(_ctx.class)
    }, null, 8, ["value", "options", "disabled", "change-on-select", "placeholder", "load-data", "onChange", "class"])
  ]))
}